import Config from '../Config';
import Helper from '../Classes/Helper';
import {writable} from 'svelte/store';

const data = {shop: '', seller: false, unswipe_color: false, configurator_renderer: false};
const registry = writable(data);

registry.apiDomain = () => {
	let uri = '';
	if (!Helper.development()) {
		const sub = Config.api.subdomain;
		const domain = Config.domain[data.shop];
		uri = `${sub}.${domain}`;
	}
	else uri = Config.api.development;
	return `https://${uri}`;
};

registry.shopDomain = () => {
	let uri = Helper.development() ? Config.shop.development : Config.domain[data.shop];
	return `https://${uri}`;
};

registry.apiUrl = uri => {
	const domain = registry.apiDomain();
	const endpoint = Config.api.endpoint;
	return uri ? `${domain}/${endpoint}/${uri}` : `${domain}/${endpoint}`;
};

registry.shopUrl = uri => {
	const domain = registry.shopDomain();
	return uri ? `${domain}/${uri}` : domain;
};

export default registry;